import { bytesToString } from "@/utils/utils";
export const DEFAULT_QUOTA_SOURCE_LABEL = "Default";
/**
 * Contains information about quota usage for a particular ObjectStore.
 */
export class QuotaUsage {
    constructor(data) {
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._data = data;
    }
    get rawSourceLabel() {
        var _a;
        return (_a = this._data.quota_source_label) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * The name of the ObjectStore associated with the quota.
     */
    get sourceLabel() {
        var _a;
        return (_a = this.rawSourceLabel) !== null && _a !== void 0 ? _a : DEFAULT_QUOTA_SOURCE_LABEL;
    }
    /**
     * The maximum allowed disk usage in bytes.
     */
    get quotaInBytes() {
        return this._data.quota_bytes;
    }
    /**
     * The total amount of bytes used in this ObjectStore.
     */
    get totalDiskUsageInBytes() {
        return this._data.total_disk_usage;
    }
    /**
     * The percentage of used quota.
     */
    get quotaPercent() {
        return this._data.quota_percent;
    }
    /**
     * The maximum allowed disk usage as human readable size.
     */
    get niceQuota() {
        if (this.isUnlimited) {
            return "unlimited";
        }
        if (this.quotaInBytes !== undefined && this.quotaInBytes !== null) {
            return bytesToString(this.quotaInBytes, true, undefined);
        }
        return "unknown";
    }
    /**
     * The total amount of disk used in this ObjectStore as human readable size.
     */
    get niceTotalDiskUsage() {
        return bytesToString(this.totalDiskUsageInBytes, true, undefined);
    }
    /**
     * Whether this ObjectStore has unlimited quota
     */
    get isUnlimited() {
        return !this.quotaInBytes;
    }
}
